import { Link } from "react-router-dom";
import { works } from "@/mocks/works";

export default function LatestSection() {
  const latest = [...works]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, 6);

  return (
    <section className="container-x py-14 md:py-20" aria-labelledby="latest-heading">
      <div className="flex items-end justify-between gap-4">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-primary-600">
            最新更新
          </span>
          <h2 id="latest-heading" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            近期更新，追更不迷路
          </h2>
        </div>
        <span className="hidden items-center gap-1 text-sm text-foreground-500 md:inline-flex">
          <i className="ri-time-line text-secondary-500" /> 按更新时间排序
        </span>
      </div>

      <div className="mt-8 flex flex-col gap-3">
        {latest.map((w, i) => (
          <Link
            key={w.id}
            to={`/work/${w.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
          >
            <span className="w-6 shrink-0 text-center font-heading text-lg font-black text-background-300">
              {i + 1}
            </span>
            <img
              src={w.cover}
              alt={`${w.title} 封面`}
              className="h-16 w-12 shrink-0 rounded-md object-cover object-top"
            />
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                {w.title}
              </h3>
              <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line" /> {w.author}
                </span>
                <span className="hidden items-center gap-1 sm:flex">
                  <i className="ri-article-line" /> {w.chapters}话
                </span>
                <span
                  className={`rounded-full px-2 py-0.5 ${
                    w.status === "连载中" ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-700"
                  }`}
                >
                  {w.status}
                </span>
              </div>
            </div>
            <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-500 md:flex">
              <i className="ri-refresh-line text-primary-500" />
              更新于 {w.updatedAt}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}